export const padelRules = [
  {
    title: 'Court Dimensions',
    type: 'info',
    diagram: {
      label: 'Court Size',
      value: '32.8\' × 65.6\''
    },
    points: [
      'Court: 10 meters (32.8 feet) wide × 20 meters (65.6 feet) long',
      'Surrounded by walls (glass and mesh)',
      'Net height: 88 cm at center, 92 cm at sides',
      'Service boxes: similar to tennis layout'
    ],
    keyFact: 'Padel courts are enclosed, making the walls part of the playing area!'
  },
  {
    title: 'Team Composition',
    type: 'info',
    diagram: {
      label: 'Players per Team',
      value: '2'
    },
    points: [
      'Always played in doubles (2 vs 2)',
      'No singles format in official padel',
      'Partners alternate serving',
      'Both players must stay on their side until serve is struck'
    ],
    keyFact: 'Padel is exclusively a doubles sport, unlike tennis which has both formats!'
  },
  {
    title: 'Scoring System',
    type: 'info',
    diagram: {
      label: 'Game Scoring',
      value: '15-30-40'
    },
    points: [
      'Same scoring as tennis: 15, 30, 40, game',
      'Sets won at 6 games (must win by 2)',
      'Tiebreak at 6-6',
      'Matches typically best of 3 sets'
    ],
    keyFact: 'Padel borrowed its scoring system directly from tennis!'
  },
  {
    title: 'Wall Play',
    type: 'do',
    points: [
      'Ball can bounce off walls on your side before hitting',
      'Can hit ball into opponent\'s walls after crossing net',
      'Ball must bounce on ground first before wall',
      'Can exit court and return ball (if physically possible)'
    ],
    keyFact: 'Using the walls strategically is key to advanced padel play!'
  },
  {
    title: 'Service Rules',
    type: 'do',
    diagram: {
      label: 'Service Style',
      value: 'Underhand'
    },
    points: [
      'Must serve underhand below waist height',
      'Ball must bounce once before serving',
      'Serve diagonally into service box',
      'Server must keep one foot behind service line'
    ],
    keyFact: 'Unlike tennis, padel serves must be underhand, making power serves impossible!'
  },
  {
    title: 'Equipment',
    type: 'info',
    points: [
      'Padel racket: solid, perforated, no strings',
      'Pressurized tennis-style balls (slightly less pressure)',
      'Racket maximum dimensions: 45.5cm × 26cm',
      'No overgrips extending beyond handle'
    ],
    keyFact: 'Padel rackets have no strings and are perforated with holes for aerodynamics!'
  }
];

export const padelGoverningBodies = [
  {
    name: 'FIP',
    description: 'International Padel Federation - Global governing body for padel with over 90 member nations. Organizes World Championships and sets international rules.',
    website: 'https://www.padelfip.com'
  },
  {
    name: 'USA Padel',
    description: 'National governing body for padel in the United States, promoting growth and organizing tournaments nationwide.',
    website: 'https://usapadel.us'
  }
];

export const padelTournaments = [
  {
    name: 'World Padel Tour',
    description: 'Premier professional padel circuit featuring the world\'s best players competing in tournaments across multiple countries.',
    website: 'https://www.worldpadeltour.com'
  },
  {
    name: 'FIP World Padel Championships',
    description: 'Biennial international championship featuring national teams from around the world competing for the world title.',
    website: 'https://www.padelfip.com/competitions/world-championship/'
  },
  {
    name: 'Premier Padel',
    description: 'Official tour backed by FIP and Qatar Sports Investments, featuring major tournaments with substantial prize money.',
    website: 'https://premierpadel.com'
  },
  {
    name: 'Pan American Padel Championships',
    description: 'Continental championship for North, Central, and South American nations.',
    website: 'https://www.padelfip.com/competitions/'
  }
];

export const padelResources = [
  {
    name: 'USA Padel Events',
    website: 'https://usapadel.us/events/'
  },
  {
    name: 'FIP Rankings',
    website: 'https://www.padelfip.com/rankings/'
  },
  {
    name: 'World Padel Tour Schedule',
    website: 'https://www.worldpadeltour.com/calendario'
  }
];
